<div class="document-controls">
  <button
    appButton
    name="DONTREPORT"
    location="document-viewer-controls"
    [iconButton]="true"
    color="simple-gray-50"
    height="0"
    shape="round"
    [appTooltip]="'Previous page'"
    (click)="previousPage()"
    [class.disabled]="!canPrevious()"
  >
    <app-svg src="/assets/icons/24/chevron-left.svg" size="0"></app-svg>
  </button>
  <span class="page-info"> {{ page() + 1 }} of {{ totalPages() }} </span>
  <button
    appButton
    name="DONTREPORT"
    location="document-viewer-controls"
    [iconButton]="true"
    color="simple-gray-50"
    height="0"
    shape="round"
    [appTooltip]="'Next page'"
    (click)="nextPage()"
    [class.disabled]="!canNext()"
  >
    <app-svg src="/assets/icons/24/chevron-right.svg" size="0"></app-svg>
  </button>
</div>
